import { Outlet, useNavigate } from 'react-router-dom';
import styles from './App.module.scss';
import Canonical from '@components/Canonical';
import { UserContext } from '@common/context';
import useUserInfo from '@hooks/useUserInfo';
import { isDev, setNavigate } from '@common/util';
import './i18n.js';

if (isDev()) {
  const VConsole = require('vconsole');
  new VConsole();
}

function App() {
  setNavigate(useNavigate());
  const { user, setUser, deviceInfo } = useUserInfo();

  return (
    <div className={styles['app']}>
      <UserContext
        value={{
          user: user,
          setUser: setUser,
          deviceInfo: deviceInfo,
        }}
      >
        <Canonical />
        <div className={styles['root']}>
          <Outlet />
        </div>
      </UserContext>
    </div>
  );
}

export default App;
